export var getErrorMessage = function getErrorMessage(error, errorMessage) {
  var _ref;

  if (error.type === 'required') return 'This field is required.';
  return (_ref = errorMessage !== null && errorMessage !== void 0 ? errorMessage : error.message) !== null && _ref !== void 0 ? _ref : 'Please enter a valid value.';
};